const calculator = () => {
  let buttons = [...document?.querySelectorAll('.calc__button')],
    display = document?.querySelector('.calc_display'),
    totalPrice = document?.querySelector('.total-price'),
    rate;

  for (let button of buttons) {
    button?.addEventListener('click', (e) => {
      e.target == buttons[0]
        ? (display.value = Number(display.value) - 1)
        : (display.value = Number(display.value) + 1);

      limiter(0, 1000);

      rate = Number(display.value);

      totalPrice.textContent = 1500 * rate;
    });
  }

  display?.addEventListener('input', inputField);

  function inputField() {

    /* Запрет на ввод кроме цифр */
    this.value = this.value.replace(/[^\d.]/g, '');

    limiter(0, 1000);

    rate = Number(display.value);
    totalPrice.textContent = 1500 * rate;
  }

  /* Ограничение по вводу максимального числа и минимального */
  function limiter(min, max) {
    if (display.value < min) {
      display.value = min;
    }

    if (display.value > max) {
      display.value = max;
    }
  }
};

export default calculator;
